import Pjax from 'pjax';

const elements = Array.from(document.querySelectorAll('.archive-page'));
if(elements.length > 0) {
  new Pjax({ // eslint-disable-line no-new
    elements: ['.posts_load-more', '.archive-page__category-link'],
    selectors: ['.archive-page', '.slider--hero', '.category-banner'],
    scrollTo: false,
    cacheBust: false,
    scrollRestoration: false,
  });
  document.addEventListener("pjax:success", (e) => {
    if (e.triggerElement?.classList.contains('posts_load-more')) {
      document.querySelector('.post-card:nth-last-of-type(9)')?.scrollIntoView();
    }
    if (e.triggerElement?.classList.contains('archive-page__category-link')) {
      window.scrollTo(0, 0);
    }
  })
}
